var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vipsignsuccess"},[_vm._m(0),_c('button',{staticClass:"btn",on:{"click":_vm.goBack}},[_vm._v("返回上一页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"img"},[_c('i',{staticClass:"iconfont iconxingzhuang22"})]),_c('div',{staticClass:"successtext"},[_vm._v("签名成功")])])
}]

export { render, staticRenderFns }